// @flow
const MediaType: PKMediaTypes = {
  VOD: 'Vod',
  LIVE: 'Live',
  AUDIO: 'Audio',
  UNKNOWN: 'Unknown'
};

export {MediaType};



// WEBPACK FOOTER //
// ./media-type.js


// WEBPACK FOOTER //
// core/media-type.js